import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import H from "history";
import ApiService from '../../ApiService';
import DispatchProps from '../../../utils/DispatchProps';
import { IRootState } from '../../../store';
import SchoolPageTitle from '../../SchoolPageTitle';

interface SchoolStudentSubmissionUnlockPageProps {
    tenantId: string;
    schoolCode: string
    history: H.History;
    apiService: ApiService;
}

interface SchoolAssignmentUnlockPageState {
}

class SchoolAssignmentUnlockPage extends Component<SchoolStudentSubmissionUnlockPageProps & DispatchProps, SchoolAssignmentUnlockPageState> {
    static displayName = SchoolAssignmentUnlockPage.name;


    constructor(props: SchoolStudentSubmissionUnlockPageProps & DispatchProps) {
        super(props);
        this.state = { }
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: Readonly<SchoolStudentSubmissionUnlockPageProps & DispatchProps>, prevState: any): Promise<void> {
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Assignment Analytics - Unlock" reverse={true} />
                <div className={"cdb-admin-content cdb-admin-content--column flex-item--flex-1"}>
                    <iframe style={{height: "1200px",border: "none" }} scrolling={"no"} src={"https://clouddesignbox.co.uk/unlock-assignment-insights/"}/>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): SchoolStudentSubmissionUnlockPageProps => {
        return {
            apiService: state.auth.apiService,
            history: ownProps.history,
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
        };
    }
)(SchoolAssignmentUnlockPage)
